@if (shown(); as templates) {
  <div class="grid gap-3 sm:grid-cols-2" role="listbox" aria-label="Vorlagen">
    @for (template of templates; track template.key) {
      <button
        type="button"
        role="option"
        class="hover:bg-muted/60 focus-visible:ring-ring flex flex-col gap-2 rounded-lg border p-3 text-left transition-colors focus-visible:ring-2 focus-visible:outline-none"
        [class.border-primary]="selectedKey() === template.key"
        [class.ring-2]="selectedKey() === template.key"
        [class.ring-primary]="selectedKey() === template.key"
        [attr.aria-selected]="selectedKey() === template.key"
        (click)="select.emit(template)">
        <div
          class="bg-muted relative w-full overflow-hidden rounded border"
          [style.aspect-ratio]="template.page_width_pt / template.page_height_pt">
          @if (showPreviews()) {
            <app-authenticated-image
              class="absolute inset-0 h-full w-full"
              [src]="previewUrl(template)"
              [retry]="false"
              [alt]="'Vorschau ' + template.label" />
          }
        </div>
        <span class="text-sm font-medium">{{ template.label }}</span>
        <span class="flex flex-wrap gap-1">
          <span hlmBadge variant="outline">{{ sizeLabel(template) }}</span>
          @if (template.needs_branding && !template.available) {
            <span
              hlmBadge
              variant="outline"
              class="max-w-full border-amber-500 whitespace-normal text-amber-700">
              Logo und Banner fehlen
            </span>
          }
        </span>
        <p hlmMuted class="text-xs">{{ template.description }}</p>
      </button>
    }
  </div>
  @if (missingBranding()) {
    <div class="bg-muted/60 mt-3 flex items-start gap-3 rounded-lg border p-3 text-sm">
      <ng-icon name="lucideImageUp" class="mt-0.5 shrink-0" />
      <div class="min-w-0 flex-1 space-y-1">
        <p>
          Dein Logo und Banner fehlen. Du kannst trotzdem schon starten; verwenden lässt sich das
          Design, sobald beide unter „Marke &amp; Branding“ hochgeladen sind.
        </p>
        <button
          hlmBtn
          variant="link"
          size="sm"
          class="h-auto p-0"
          type="button"
          (click)="uploadBranding.emit()">
          Jetzt hochladen
        </button>
      </div>
    </div>
  }
} @else {
  <div class="grid gap-3 sm:grid-cols-2" aria-busy="true">
    <hlm-skeleton class="h-64 w-full" />
    <hlm-skeleton class="h-64 w-full" />
  </div>
}
